import type { FileOpenErrorViewProps } from './components/FileOpenErrorView';
import type * as lazyIndex from './lazyIndex';
import { LazyAction, type LazyComponent, LazyModule, createLazyComponent } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import('./lazyIndex'),
    {
        name: 'owa-mail-file-support/lazyFunctions',
    }
);
export const lazyOpenFileMessage: LazyAction<typeof lazyIndex.openFileMessage, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.openFileMessage);
export const lazyConvertFileToMessageInService: LazyAction<
    typeof lazyIndex.convertFileToMessageInService,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.convertFileToMessageInService);
export const lazyOnDropFile: LazyAction<typeof lazyIndex.onDropFile, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.onDropFile);
export const lazyPopoutFileMessage: LazyAction<
    typeof lazyIndex.popoutFileMessage,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.popoutFileMessage);
export const FileOpenErrorView: LazyComponent<FileOpenErrorViewProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.FileOpenErrorView);
export const lazyCreateCopyItem: LazyAction<typeof lazyIndex.createCopyItem, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.createCopyItem);
export const lazyCreateCopyItemFailedNotification: LazyAction<
    typeof lazyIndex.createCopyItemFailedNotification,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.createCopyItemFailedNotification);
export const lazyIsTabFileActivation: LazyAction<
    typeof lazyIndex.isTabFileActivation,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.isTabFileActivation);
export const lazyIsTabFileActivationCached: LazyAction<
    typeof lazyIndex.isTabFileActivationCached,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.isTabFileActivationCached);
